"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElevationStyles = void 0;
var _react = require("react");
var _ElevationProvider = require("@cbhq/cds-common/context/ElevationProvider");
var _useSpectrumConditional = require("@cbhq/cds-common/hooks/useSpectrumConditional");
var _elevation = require("@cbhq/cds-common/tokens/elevation");
var _cdsUtils = require("@cbhq/cds-utils");
var _usePaletteToCssVars = require("../color/usePaletteToCssVars");
const useElevationStyles = elevation => {
  const paletteCssVars = (0, _usePaletteToCssVars.usePaletteToCssVars)();
  const paletteOverrides = (0, _useSpectrumConditional.useSpectrumConditional)({
    light: _cdsUtils.emptyObject,
    dark: paletteCssVars
  });
  const childOverrides = (0, _ElevationProvider.useElevationChildOverrides)();
  return (0, _react.useMemo)(() => {
    if (childOverrides) return paletteOverrides;
    if (!elevation) return _cdsUtils.emptyObject;
    const _elevationTokens$elev = _elevation.elevation[elevation],
      shadowOffset = _elevationTokens$elev.shadowOffset,
      shadowRadius = _elevationTokens$elev.shadowRadius,
      shadowOpacity = _elevationTokens$elev.shadowOpacity;
    const boxShadow = `${shadowOffset.width}px ${shadowOffset.height}px ${shadowRadius}px rgba(0, 0, 0, ${shadowOpacity})`;
    return Object.assign({}, paletteOverrides, {
      boxShadow
    });
  }, [elevation, childOverrides, paletteOverrides]);
};
exports.useElevationStyles = useElevationStyles;